"use client";

import { useEffect } from "react";
import { AlertCircle } from "lucide-react";

import { Button } from "@/components/ui/button";

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <section className="w-full max-w-md rounded-xl border bg-card p-6 text-center shadow-xs">
        <AlertCircle className="mx-auto mb-4 size-10 text-destructive" />
        <h1 className="text-lg font-semibold">Az oldal nem tölthető be</h1>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
          {error.message || "Váratlan hiba történt a megjelenítés közben."}
        </p>
        <Button type="button" className="mt-5" onClick={reset}>
          Újrapróbálás
        </Button>
      </section>
    </div>
  );
}
